import { BlueprintVersionedGroup } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellSpace from "ds/components/Table/Row/CellSpace";

const TemplatesTableSpaceCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<BlueprintVersionedGroup>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellSpace href={`/spaces/${template.space.id}`}>{template.space.name}</TableCellSpace>
    </TableSimpleCell>
  );
};

export default TemplatesTableSpaceCell;
